<template>
  <a :href="'tel:' + raw" dir="ltr">
    <slot>
      {{ display }}
    </slot>
  </a>
</template>
<script setup lang="ts">
const { raw, display } = useCommunication().phone;
</script>